import {
    CloudUploadIcon,
    CogIcon,
    LockClosedIcon,
    RefreshIcon,
    ServerIcon,
    ShieldCheckIcon,
} from '@heroicons/react/outline'

const features = [
    {name: 'Scouting', description: "Scoutli offers an extensive range of player database with advanced analytics and player ratings.", icon: CloudUploadIcon},
    {name: 'Team Management', description: "Scoutli enables teams to track their financials, important dates, players' data, and more. Data-driven player management.", icon: LockClosedIcon},
    {name: 'Scrim Finder', description: "Create and find scrims on League of Legends, VALORANT, Wild Rift, and more.", icon: RefreshIcon},
    {name: 'Data as a Service', description: "We make finding and using reliable data for your esports events easy. Bringing Data to the game.", icon: ShieldCheckIcon},
    {name: 'Statistical Reports', description: "Scoutli offers a variety of reports to help you: Tournament Performance, Player Scouting and Player Performance.", icon: CogIcon},
    {name: 'Coaching Tools', description: "Scoutli got you covered with tools to level up your game: Playbooks, Lineups, Heatmaps, 2D Replays, Map planner & more.", icon: ServerIcon},
]

const Features = () => {
    return (
        <div className="relative bg-white py-16 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
                <h2 className="text-base font-semibold tracking-wider text-indigo-600 uppercase">Scout. Analyze. Optimize.</h2>

                <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                    A new way to scout, analyze and develop
                </p>

                <p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
                    We are enabling esports organizations to focus on what matters, their players.
                </p>

                <div className="mt-12">
                    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                        {features.map((feature) => (
                            <div key={feature.name} className="pt-6">
                                <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                                    <div className="-mt-6">
                                        <div>
                                            <span className="inline-flex items-center justify-center p-3 bg-brand rounded-md shadow-lg">
                                                <feature.icon className="h-6 w-6 text-white" aria-hidden="true"/>
                                            </span>
                                        </div>

                                        <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">{feature.name}</h3>

                                        <p className="mt-5 text-base text-gray-500">
                                            {feature.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features;